// Edit authored content with blocking WhatsApp Flow display validation.
import { flowFieldErrors } from "./flowFieldValidation";
import FlowFieldErrors from "./FlowFieldErrors";
import FlowDraftPanel from './FlowDraftPanel';
// Edit V1 questionnaire settings, rewards and independent WhatsApp discovery options.
import FlowLengthHint from "./FlowLengthHint";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import _ from "lodash";
import { toast } from "react-toastify";
import {
  Form,
  Button,
  Icon,
  Checkbox,
  Divider,
  Dropdown,
  Table,
  Container,
  Dimmer,
  Loader,
  Confirm,
  Segment,
  Tab,
  Header
} from "semantic-ui-react";
import * as QUESTIONAIRE_ACTIONS from "../../../actions/questionaireActions";
import * as QUESTIONAIRE_TYPE_ACTIONS from "../../../actions/questionaireTypeActions";
import * as QNAIREBR_ACTIONS from "../../../actions/brQnaireActions";
import * as COUNTRY_CODES_ACTION from "../../../actions/countryCodesActions";
import * as EXTERNAL_API_ACTIONS from "../../../actions/externalApiActions";
import { AVAILABLE_TRANSLATION_LANGUAGES as AVAILABLE_LANGUAGES } from "../../../constants/translations";
import ApiDocumentationTab from "./ApiDocumentationTab";

const ROOT_QUESTIONNAIRE_TYPES = [
  { key: 1, text: "My Profile", value: "My Profile", Description: "My Profile" },
  { key: 2, text: "My Home and Properties", value: "My Home and Properties", Description: "My Home and Properties" },
  { key: 3, text: "My Skills and Work Experience", value: "My Skills and Work Experience", Description: "My Skills and Work Experience" },
  { key: 4, text: "My Will and Testament", value: "My Will and Testament", Description: "My Will and Testament" },
  { key: 5, text: "POPIA", value: "POPIA", Description: "POPIA" },
  { key: 6, text: "Community Marketplace", value: "Community Marketplace", Description: "Community Marketplace" },
  { key: 7, text: "Business Registration", value: "Business Registration", Description: "Business Registration" },
  { key: 7, text: "Incident Report", value: "Incident Report", Description: "Incident Report" },
];

const COUNTRY_CODES = [
  { key: "MZN", value: "mozambique", text: "Mozambique", code: "+258" },
  { key: "ZAR", value: "south_africa_2", text: "South Africa", code: "+27" },
];

// Number formatting utility functions
const formatNumberWithCommas = (value) => {
  if (!value) return '';
  const parts = value.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

const parseFormattedNumber = (value) => {
  return value.replace(/,/g, '');
};

// Referral Reward Input Component
const ReferralRewardInput = ({ state, updateQuestionnaireState, currencyList, handleWheel }) => {
  const [localReferralValue, setLocalReferralValue] = useState(
    state.questionaire.referralRewardValue ? formatNumberWithCommas((state.questionaire.referralRewardValue / 100).toString()) : ''
  );

  useEffect(() => {
    setLocalReferralValue(
      state.questionaire.referralRewardValue ? formatNumberWithCommas((state.questionaire.referralRewardValue / 100).toString()) : ''
    );
  }, [state.questionaire.referralRewardValue]);

  const handleReferralChange = (e) => {
    const inputValue = parseFormattedNumber(e.target.value);
    const formattedValue = formatNumberWithCommas(inputValue);
    setLocalReferralValue(formattedValue);

    if (inputValue === '' || inputValue === '0') {
      updateQuestionnaireState({ referralRewardValue: 0 });
    } else {
      const numericValue = parseFloat(inputValue);
      if (!isNaN(numericValue) && numericValue >= 0) {
        updateQuestionnaireState({ referralRewardValue: Math.round(numericValue * 100) });
      }
    }
  };

  const currencyOptions = [
    { key: "none", text: "None", value: "None" },
    ...currencyList.map((code) => ({
      key: code.key,
      text: code.key,
      value: code.key,
    })),
  ];

  return (
    <div style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}>
      <Dropdown
        fluid
        placeholder="Currency"
        search
        selection
        style={{ minWidth: "120px", maxWidth: "150px" }}
        options={currencyOptions}
        value={state.questionaire.referralRewardCurrency || "None"}
        onChange={(e, { value: selectedValue }) => {
          updateQuestionnaireState({ referralRewardCurrency: selectedValue });
        }}
      />
      <input
        type="text"
        placeholder=""
        style={{
          flex: 1,
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          fontSize: "14px"
        }}
        value={localReferralValue}
        onChange={handleReferralChange}
        onWheel={handleWheel}
      />
    </div>
  );
};

// Reward Dropdown Component
const RewardDropdown = ({ state, updateQuestionnaireState, currencyList, control, handleWheel }) => {
  const [localRewardValue, setLocalRewardValue] = useState(
    state.questionaire.qnaireReward ? formatNumberWithCommas((state.questionaire.qnaireReward / 100).toString()) : ''
  );

  useEffect(() => {
    setLocalRewardValue(
      state.questionaire.qnaireReward ? formatNumberWithCommas((state.questionaire.qnaireReward / 100).toString()) : ''
    );
  }, [state.questionaire.qnaireReward]);

  const handleRewardChange = (e) => {
    const inputValue = parseFormattedNumber(e.target.value);
    const formattedValue = formatNumberWithCommas(inputValue);
    setLocalRewardValue(formattedValue);

    if (inputValue === '' || inputValue === '0') {
      updateQuestionnaireState({ qnaireReward: 0 });
    } else {
      const numericValue = parseFloat(inputValue);
      if (!isNaN(numericValue) && numericValue >= 0) {
        updateQuestionnaireState({ qnaireReward: Math.round(numericValue * 100) });
      }
    }
  };

  const currencyOptions = [
    { key: "none", text: "None", value: "None" },
    ...currencyList.map((code) => ({
      key: code.key,
      text: code.key,
      value: code.key,
    })),
  ];

  return (
    <Controller
      name="currency"
      control={control}
      defaultValue={state.questionaire.qnaireRewardCurrency || "None"}
      rules={{
        validate: (value) => {
          if (state.questionaire.qnaireReward > 0 && value === "None") {
            return "Please select a currency when reward amount is greater than 0.";
          }
          return true;
        },
      }}
      render={({ field: { onChange, value }, fieldState }) => (
        <div>
          <div style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}>
            <Dropdown
              className={fieldState.error ? "invalid-input-field" : ""}
              fluid
              placeholder="Currency"
              search
              selection
              style={{ minWidth: "120px", maxWidth: "150px" }}
              options={currencyOptions}
              value={value || state.questionaire.qnaireRewardCurrency || "None"}
              onChange={(e, { value: selectedValue }) => {
                onChange(selectedValue);
                updateQuestionnaireState({ qnaireRewardCurrency: selectedValue });
              }}
            />
            <input
              type="text"
              placeholder=""
              style={{
                flex: 1,
                padding: "8px 12px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                fontSize: "14px"
              }}
              value={localRewardValue}
              onChange={handleRewardChange}
              onWheel={handleWheel}
            />
          </div>
          {fieldState.error && (
            <p className="validation-error">{fieldState.error.message}</p>
          )}
        </div>
      )}
    />
  );
};

// Translations Tab Component (moved outside to prevent re-creation)
const TranslationsTab = ({ questionaire, updateTranslation }) => {
  const selectedLanguages = questionaire.languages || [];

  return (
    <Segment>
      {selectedLanguages.map((langCode) => {
        const language = AVAILABLE_LANGUAGES.find(lang => lang.value === langCode);
        const languageName = language ? language.text : langCode;

        return (
          <div key={langCode} style={{ marginBottom: '20px' }}>
            <h4>{languageName}</h4>
            <Form.Field>
              <label>Name Translation:</label>
              <input
                placeholder={`Enter name translation for ${languageName}`}
                value={questionaire.translations?.name?.[langCode] || ''}
                onChange={(e) => updateTranslation('name', langCode, e.target.value)}
              />
              <FlowLengthHint value={questionaire.translations?.name?.[langCode]} limit={30} />
            </Form.Field>
            <Form.Field>
              <label>Description Translation:</label>
              <textarea
                rows={3}
                placeholder={`Enter description translation for ${languageName}`}
                value={questionaire.translations?.description?.[langCode] || ''}
                onChange={(e) => updateTranslation('description', langCode, e.target.value)}
              />
              <FlowLengthHint value={questionaire.translations?.description?.[langCode]} limit={300} />
            </Form.Field>
            <Divider />
          </div>
        );
      })}
    </Segment>
  );
};

export function QuestionaireDetails(props) {
  const history = useHistory();
  const [state, setState] = useState({
    questionaire: { ...props.questionaire, whatsappShareVisible: props.questionaire.whatsappShareVisible ?? (props.questionaire.whatsappMenuVisible === true) },
    showConfirmIsActive: false,
    showConfirmEditIsActive: false,
    activeTab: 0,
  });

  const [currencyList, setCurrencyList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rewardInputValue, setRewardInputValue] = useState('');

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    control,
  } = useForm({
    mode: "all",
    reValidateMode: "onBlur",
  });

  // Effects
  useEffect(() => {
    props.fetchQuestionaireTypes();
    props.fetchCountryCodes();
    props.fetchQnaireBRs(props.questionaire);
    props.fetchAllQnaires();
    props.fetchTenantCurrencies(props.tenant);

    // Set default countryCode if not already set
    if (!state.questionaire.countryCode && props.tenant?.operatingCountry) {
      updateQuestionnaireState({ countryCode: props.tenant.operatingCountry });
    }
  }, []);

  // let codeslist = [];

  // let codeNone = {
  //   key: 1,
  //   value: '',
  //   text: ' None',
  // };
  // codeslist.push(codeNone);

  // Made the Country Codes hard coded!
  // codeslist.push({ key: "MZN", value: "mozambique", text: "Mozambique", code: "+258" },);
  // codeslist.push({ key: "ZAR", value: "south_africa_2", text: "South Africa", code: "+27" },);


  // codeslist = codeslist.map((item) => {
  //   // Safely check if props.tenant.operatingCountry.key exists
  //   if (
  //     props?.tenant?.operatingCountry?.key &&
  //     item.key === props.tenant?.operatingCountry.key
  //   ) {
  //     return props.tenant?.operatingCountry;
  //   }
  //   return item;
  // });



  // toast(codeslist);

  // props.tenant.operatingCountry


  // props.tenantCurrencies?.forEach((code, index) => {
  //   code = {
  //     key: code,
  //     value: code,
  //     text: code,
  //   };
  //   currencyList.push(code);
  // });

  useEffect(() => {
    if (props.tenantCurrencies) {
      const updatedCurrencyList = Object.entries(props.tenantCurrencies).map(([key, value]) => ({
        key,
        value,
        text: key,
      }));
      setCurrencyList(updatedCurrencyList);
      setLoading(false);
    }
  }, [props.tenantCurrencies]);

  useEffect(() => {
    setRewardInputValue(state.questionaire.qnaireReward ? (state.questionaire.qnaireReward / 100).toString() : '');
  }, [state.questionaire.qnaireReward]);

  // Utility functions
  const updateQuestionnaireState = (updates) => {
    setState((prevState) => ({
      ...prevState,
      questionaire: { ...prevState.questionaire, ...updates },
    }));
  };

  const updateTranslation = (field, language, value) => {
    const translations = state.questionaire.translations || {};
    const fieldTranslations = translations[field] || {};

    updateQuestionnaireState({
      translations: {
        ...translations,
        [field]: {
          ...fieldTranslations,
          [language]: value
        }
      }
    });
  };

  const handleWheel = (e) => {
    e.target.blur();
  };

  const validateActivationPhrase = () => {
    if (state.questionaire.isActive && state.questionaire.defaultQuestionnaire) {
      const activeDefaultQuestionnaires = props.allQuestionaires?.filter(
        (questionaire) =>
          (questionaire.isActive || questionaire.status === "underReview") &&
          questionaire.defaultQuestionnaire &&
          questionaire.id !== state.questionaire.id
      ) || [];

      const duplicateActivationPhrase = activeDefaultQuestionnaires.some(
        (questionaire) => questionaire.activationPhrase === state.questionaire.activationPhrase
      );

      if (duplicateActivationPhrase) {
        toast.error(`Activation Phrase: '${state.questionaire.activationPhrase}' already in use. Please use a different phrase.`);
        return false;
      }
    }
    return true;
  };

  // Event handlers
  const flowErrors = flowFieldErrors(state.questionaire, state.questionaire, "questionnaire");

  const onSubmit = async (data) => {
    if (flowErrors.length) return;
    const isQuestionnaireActive = props.questionaire.status === "active" || props.questionaire.status === "underReview";

    if (isQuestionnaireActive) {
      setState((state) => ({ ...state, showConfirmEditIsActive: true }));
      return;
    }

    if (!validateActivationPhrase()) {
      return;
    }

    if (!state.questionaire.countryCode) {
      updateQuestionnaireState({ countryCode: props.tenant.operatingCountry });
    }

    props.commitQuestionaire(state.questionaire, props.isNew);
    if (!_.isEmpty(props.onComplete)) {
      props.onComplete();
    }
    history.push('/Questionnaires');
  };

  const handleToggleChange = (field) => {
    const newValue = !state.questionaire[field];
    const updates = { [field]: newValue };

    // Ensure defaultQuestionnaire and referralReward are mutually exclusive
    if (field === 'defaultQuestionnaire' && newValue) {
      updates.referralReward = false;
    } else if (field === 'referralReward' && newValue) {
      updates.defaultQuestionnaire = false;
    }

    // If defaultQuestionnaire is being disabled, also disable referralReward
    if (field === 'defaultQuestionnaire' && !newValue) {
      updates.referralReward = false;
    }

    updateQuestionnaireState(updates);
  };

  const handleIsActiveChange = () => {
    const isExistingActive = ROOT_QUESTIONNAIRE_TYPES.some(
      (rootQuestionaire) =>
        rootQuestionaire.value === state.questionaire.questionaireType &&
        props.questionaires?.some(
          (questionaire) =>
            questionaire.isActive &&
            questionaire.questionaireType === state.questionaire.questionaireType &&
            questionaire.countryCode?.value === state.questionaire.countryCode?.value
        )
    );

    if (isExistingActive) {
      updateQuestionnaireState({ isActive: false });
      toast.error(`There is already an active questionnaire of type: ${state.questionaire.questionaireType}`);
    } else if (state.questionaire.status === "underReview") {
      updateQuestionnaireState({ status: 'inActive' });
    } else {
      setState((state) => ({ ...state, showConfirmIsActive: true }));
    }
  };

  // Dropdown components
  const QuestionnaireTypesDropdown = () => {
    let questionaireTypes = [];

    if (!_.isEmpty(props.questionaireTypes)) {
      if (props.tenant.isRoot) {
        questionaireTypes = [
          ...ROOT_QUESTIONNAIRE_TYPES,
          ...props.questionaireTypes.map((item, index) => ({
            key: index + ROOT_QUESTIONNAIRE_TYPES.length,
            value: item.Name,
            text: item.Name,
          })),]
        // ].sort((a, b) => a.text.localeCompare(b.text));
      } else {
        questionaireTypes = props.questionaireTypes.map((item, index) => ({
          key: index,
          value: item.Name,
          text: item.Name,
        })).sort((a, b) => a.text.localeCompare(b.text));
      }
    }

    const defaultValue = state.questionaire.questionaireType || "";

    return (
      <Controller
        name="questionaire_type"
        control={control}
        defaultValue={defaultValue}
        render={({ field: { onChange, value, ref }, fieldState }) => (
          <div>
            <div ref={ref} tabIndex={-1} className="dropdown-wrapper">
              <Dropdown
                className={fieldState.error ? "invalid-input-field" : ""}
                fluid
                placeholder="Select questionnaire type"
                search
                selection
                loading={props.fetchingData}
                options={questionaireTypes}
                value={value || defaultValue}
                onChange={(e, { value: selectedValue }) => {
                  onChange(selectedValue);
                  updateQuestionnaireState({
                    isActive: false,
                    questionaireType: selectedValue
                  });
                }}
              />
            </div>
            {fieldState.error && (
              <p className="validation-error">* Select a type</p>
            )}
          </div>
        )}
      />
    );
  };

  const LanguagesDropdown = () => (
    <Controller
      name="questionaire_languages"
      control={control}
      rules={{ required: false }}
      render={({ field: { onChange, value }, fieldState }) => (
        <div>
          <Dropdown
            className={fieldState.invalid ? "invalid-input-field" : ""}
            placeholder="Select languages"
            fluid
            multiple
            selection
            search
            options={AVAILABLE_LANGUAGES}
            value={(state.questionaire.languages || []).filter(lang => lang !== 'en')}
            onChange={(e, { value: selectedValue }) => {
              const languagesWithEnglish = selectedValue.length > 0
                ? ['en', ...selectedValue]
                : [];
              onChange(languagesWithEnglish);
              updateQuestionnaireState({
                isActive: false,
                languages: languagesWithEnglish
              });
            }}
          />
        </div>
      )}
    />
  );

  const CountryCodeDropdown = () => {
    const codeslist = COUNTRY_CODES.map((item) => {
      if (props?.tenant?.operatingCountry?.key && item.key === props.tenant.operatingCountry.key) {
        return props.tenant.operatingCountry;
      }
      return item;
    });

    const defaultValue = state.questionaire.countryCode?.value || props.tenant?.operatingCountry?.value || "";

    return (
      <Controller
        name="questionnaire_countrycode"
        control={control}
        rules={{ required: false }}
        defaultValue={defaultValue}
        render={({ field, fieldState }) => (
          <div>
            <Dropdown
              className={fieldState.invalid ? "invalid-input-field" : ""}
              {...field}
              placeholder="Select country code"
              fluid
              selection
              search
              options={codeslist}
              value={defaultValue}
              onChange={(e, { value }) => {
                const selectedObject = codeslist.find(option => option.value === value);
                updateQuestionnaireState({ countryCode: selectedObject });
                field.onChange(value);
              }}
            />
          </div>
        )}
      />
    );
  };

  // Table components
  const BusinessRulesTable = () => {
    if (props.fetchingData) {
      return (
        <div style={{ height: "200px", margin: "10px 0px" }}>
          <Dimmer inverted active>
            <Loader content='Loading' />
          </Dimmer>
        </div>
      );
    }

    if (_.isEmpty(props.qnaireBRs)) {
      return null;
    }

    return (
      <Table compact selectable size='small'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell className='nectaPrimaryBg'>
              Business Rules linked to Questionnaire
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {props.qnaireBRs.map(qnaireBR => (
            <Table.Row key={qnaireBR.id}>
              <Table.Cell>{qnaireBR.brName}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  };

  // Toggle components
  const ToggleField = ({ label, field, disabled = false, onChange = null }) => (
    <Form.Field>
      <Checkbox
        toggle
        label={label}
        checked={!!state.questionaire[field]}
        disabled={disabled}
        onChange={onChange || (() => handleToggleChange(field))}
      />
    </Form.Field>
  );

  // Confirmation dialogs
  const ConfirmActivate = () => {
    const contentMessage = state.questionaire.isActive
      ? "Are you sure you want to deactivate the questionnaire? The questionnaire will need to undergo the review process again if re-activated."
      : "Once the questionnaire is activated and saved, it will undergo a review process. If the review is successful, the questionnaire will become active.";

    return (
      <Confirm
        header='Warning:'
        content={contentMessage}
        open={state.showConfirmIsActive}
        onCancel={() => setState((state) => ({ ...state, showConfirmIsActive: false }))}
        onConfirm={() => {
          if (flowErrors.length) return;
          updateQuestionnaireState({ isActive: !state.questionaire.isActive });
          setState((state) => ({ ...state, showConfirmIsActive: false }));
        }}
      />
    );
  };

  const ConfirmEditActive = () => {
    const contentMessage = "The questionnaire is currently active or under review. Editing any part of the questionnaire will result in its deactivation, requiring it to undergo the review process again.";

    return (
      <Confirm
        header='Warning:'
        content={contentMessage}
        open={state.showConfirmEditIsActive}
        onCancel={() => setState((state) => ({ ...state, showConfirmEditIsActive: false }))}
        onConfirm={() => {
          if (flowErrors.length) return;
          if (!validateActivationPhrase()) {
            return;
          }

          const updatedQuestionaire = { ...state.questionaire, status: "inActive" };
          props.commitQuestionaire(updatedQuestionaire, props.isNew);
          if (!_.isEmpty(props.onComplete)) {
            props.onComplete();
          }
          history.push('/Questionnaires');
        }}
      />
    );
  };

  // Render form content function
  const renderFormContent = () => (
    <>
      {/* Basic Information */}
      <Form.Field>
        <label>Questionnaire Name:</label>
        <input
          name="questionaire_name"
          className={errors.questionaire_name ? "invalid-input-field" : ""}
          {...register("questionaire_name", {
            required: true,
            pattern: /^[A-Za-z0-9-\s]*$/
          })}
          placeholder="Enter questionnaire name"
          value={state.questionaire.name}
          onChange={(e) => {
            const inputValue = e.target.value;
            if (inputValue.length <= 50) {
              updateQuestionnaireState({ name: inputValue });
            }
          }}
        />
        <FlowLengthHint value={state.questionaire.name} limit={30} />
        {errors.questionaire_name?.type === "required" && (
          <p className="validation-error">* Please enter a name</p>
        )}
        {errors.questionaire_name?.type === "pattern" && (
          <p className="validation-error">* May only contain alphanumerical characters and "-"</p>
        )}
      </Form.Field>

      {!props.isNew && (
        <Form.Field>
          <label>Merge Field:</label>
          <input
            className="visible-input"
            value={state.questionaire.pptRef}
            disabled
          />
        </Form.Field>
      )}

      <Form.Field>
        <label>Description:</label>
        <textarea
          name="questionaire_description"
          className={errors.questionaire_description ? "invalid-input-field" : ""}
          {...register("questionaire_description", {
            required: true,
            maxLength: 512,
          })}
          placeholder="Enter a description for the questionnaire"
          value={state.questionaire.description}
          onChange={(e) => updateQuestionnaireState({ description: e.target.value })}
        />
        <FlowLengthHint value={state.questionaire.description} limit={300} />
        {errors.questionaire_description?.type === "required" && (
          <p className="validation-error">* Please enter a description</p>
        )}
        {errors.questionaire_description?.type === "maxLength" && (
          <p className="validation-error">* Description may not be more than 512 characters long</p>
        )}
      </Form.Field>

      <Form.Field>
        <label>Questionnaire Category:</label>
        <QuestionnaireTypesDropdown />
      </Form.Field>

      <Form.Field>
        <label>Questionnaire Completion Reward:</label>
        <RewardDropdown
          state={state}
          updateQuestionnaireState={updateQuestionnaireState}
          currencyList={currencyList}
          control={control}
          handleWheel={handleWheel}
        />
      </Form.Field>

      {props.tenant.isRoot && (
        <Form.Field>
          <label>Select a Country Code:</label>
          <CountryCodeDropdown />
        </Form.Field>
      )}

      {/* Toggle Section */}
      <Segment>
        <h4>Participation and data</h4>
        <Form.Group widths="equal">
          <ToggleField label="Users can have more than one" field="multiple" />
          <ToggleField
            label="Is Active"
            field="isActive"
            disabled={props.isNew}
            onChange={handleIsActiveChange}
          />
          <ToggleField
            label="Anonymise Data"
            field="anonymisedData"
            disabled={state.questionaire.alwaysAnonymise}
          />
        </Form.Group>

        <Form.Group widths="equal">
          <ToggleField label="Personal Information" field="isPersonalInfo" />
          <ToggleField label="Can Edit Questionnaire Once Completed" field="canEditQnaire" />
          {props.tenant.isRoot && (
            <ToggleField label="Is Base Questionnaire" field="isBaseQnaire" />
          )}
        </Form.Group>

        <Container>
          <BusinessRulesTable />
        </Container>

        <Divider />

        <h4>WhatsApp Flows</h4>
        <FlowDraftPanel questionnaire={props.questionaire} />
        <Form.Group widths="equal">
          <ToggleField label="Include under Questionnaires" field="whatsappMenuVisible" />
          <ToggleField label="Include under Share" field="whatsappShareVisible" disabled={!props.isTenantZero} />
        </Form.Group>
        <p>Share inclusion is configured by TenantZero administrators. It also requires referral rewards and a sharing code. Only active, configured Flows appear.</p>
        <Divider />
        <h4>WhatsApp activation</h4>
        <Form.Group widths="equal">
          <ToggleField label="Default WhatsApp Questionnaire" field="defaultQuestionnaire" />

        </Form.Group>

        {state.questionaire.defaultQuestionnaire && (
          <Form.Field>
            <label>Activation Phrase:</label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ marginRight: '5px' }}>Hello</div>
              <input
                name="activationPhrase"
                className={errors.activationPhrase ? "invalid-input-field" : ""}
                {...register("activationPhrase", {
                  required: true,
                  maxLength: 45,
                })}
                placeholder="Enter the rest of the activation phrase"
                value={state.questionaire.activationPhrase?.replace(/^Hello /i, '') || ''}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/_/g, ''); // Remove underscores
                  const cleanedValue = inputValue.toLowerCase() === 'hello' ? '' : inputValue;
                  if (cleanedValue.length <= 50) {
                    updateQuestionnaireState({ activationPhrase: `Hello ${cleanedValue}` });
                  }
                }}
              />
            </div>
            {errors.activationPhrase?.type === "required" && (
              <p className="validation-error">* Please enter an activation phrase</p>
            )}
            {errors.activationPhrase?.type === "maxLength" && (
              <p className="validation-error">* Activation phrase may not be more than 50 characters long</p>
            )}
          </Form.Field>
        )}

        <Form.Group widths="equal">
          <ToggleField label="Translate Questionnaire" field="translateQnaire" />
        </Form.Group>

        {state.questionaire.translateQnaire && (
          <Form.Field>
            <label>Select Languages to Translate in:</label>
            <LanguagesDropdown />
          </Form.Field>
        )}

        <Form.Group widths="equal">
          <ToggleField label="Referral Reward" field="referralReward" />
        </Form.Group>

        {state.questionaire.referralReward && (
          <Form.Field>
            <label>Referral Reward Amount:</label>
            <ReferralRewardInput
              state={state}
              updateQuestionnaireState={updateQuestionnaireState}
              currencyList={currencyList}
              handleWheel={handleWheel}
            />
          </Form.Field>
        )}
      </Segment>
    </>
  );

  return (
    <Segment style={{ backgroundColor: 'white', padding: '20px' }}>
      <Form size="small" onSubmit={handleSubmit(onSubmit)}>
        <FlowFieldErrors errors={flowErrors} />
        <ConfirmActivate />
        <ConfirmEditActive />

        {state.questionaire.translateQnaire && !props.isNew ? (
          <Tab
            activeIndex={state.activeTab}
            onTabChange={(e, { activeIndex }) => setState(prev => ({ ...prev, activeTab: activeIndex }))}
            panes={[
              {
                menuItem: 'General',
                render: () => <Tab.Pane>{renderFormContent()}</Tab.Pane>
              },
              {
                menuItem: 'Translations',
                render: () => <Tab.Pane><TranslationsTab questionaire={state.questionaire} updateTranslation={updateTranslation} /></Tab.Pane>
              }
            ]}
          />
        ) : (
          renderFormContent()
        )}

        <Divider />
        <Button.Group floated="right">
          <Button
            type="button"
            className="danger"
            onClick={() => history.push('/Questionnaires')}
          >
            <Icon name="remove" /> Cancel
          </Button>
          <Button type="submit" className="success">
            <Icon name="checkmark" /> Ok
          </Button>
        </Button.Group>
        <br />
      </Form>
    </Segment>
  );
}

const mapStateToProps = (state, ownProps) => {
  let questionaire = {};
  let isNew = false;

  const newQuestionaire = {
    name: "",
    description: "",
    countryCode: "",
    multiple: false,
    defaultQuestionnaire: false,
    whatsappMenuVisible: false,
    whatsappShareVisible: false,
    pptRef: "",
    isActive: false,
    isBaseQnaire: false,
    isPersonalInfo: false,
    canEditQnaire: false,
    hasPptTemplates: false,
    translateQnaire: false,
    referralReward: false,
    questionaireType: "",
    languages: [],
    status: "inActive",
    activationPhrase: "",
    referralRewardValue: 0,
    referralRewardCurrency: "None",
    tenantId: state.tenantManagement.activeTenant.tenantId,
  };

  // Check if questionnaire data comes from route state (for navigation) or props (for modal)
  const routeQuestionaire = ownProps.location?.state?.questionaire;
  const routeQuestionaires = ownProps.location?.state?.questionaires;

  if (routeQuestionaire) {
    // Use questionnaire from route state
    questionaire = routeQuestionaire;
    isNew = false;
  } else if (ownProps.questionaire === undefined) {
    questionaire = newQuestionaire;
    isNew = true;
  } else {
    questionaire = _.isEmpty(ownProps.questionaires)
      ? newQuestionaire
      : ownProps.questionaires.find(q => q.id === ownProps.questionaire.id) || newQuestionaire;
  }

  const questionaireTypes = _.isEmpty(state.questionaireTypes) ? [] : Object.values(state.questionaireTypes);
  const chatbotQuestionaireType = questionaireTypes.find(
    (questionaireType) => questionaireType.Name.toLowerCase() === "chatbot"
  ) || {};

  const qnaireBRs = _.isEmpty(state.qnaireBRs)
    ? []
    : state.qnaireBRs.filter((qnaireBR) => qnaireBR.qnaireId === questionaire.id);

  return {
    isTenantZero: (state.authData?.[0]?.signInUserSession?.accessToken?.payload?.['cognito:groups'] || []).includes('TenantZero'),
    fetchingData: state.fetchingData === true,
    questionaire,
    questionaireTypes: state.questionaireTypes,
    chatbotQuestionaireType,
    questionaires: state.questionaires,
    allQuestionaires: state.allQuestionnaires,
    isNew,
    qnaireBRs,
    countryCodes: _.isEmpty(state.countryCodes) ? [] : _.sortBy(state.countryCodes, 'countryCode'),
    tenant: state.tenantManagement.activeTenant,
    tenantCurrencies: state.tenantFinances?.tenantBalances?.currencies,
    externalApi: state.externalApi
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchQuestionaireTypes: () => dispatch(QUESTIONAIRE_TYPE_ACTIONS.fetchQuestionaireTypesAction()),
  fetchCountryCodes: () => dispatch(COUNTRY_CODES_ACTION.fetchCountryCodesAction()),
  commitQuestionaire: (questionaire, isNewItem) => dispatch(QUESTIONAIRE_ACTIONS.questionaireSaveAction(questionaire, isNewItem)),
  fetchAllQnaires: () => dispatch(QUESTIONAIRE_ACTIONS.fetchAllQnairesAction()),
  fetchQnaireBRs: (questionaire) => dispatch(QNAIREBR_ACTIONS.fetchbRQnairesAction(questionaire)),
  fetchTenantCurrencies: (tenant) => dispatch(QUESTIONAIRE_ACTIONS.fetchTenantBalances(tenant)),
  toggleQuestionnaireApiAccess: (questionnaireId, tenantId, enabled) => dispatch(EXTERNAL_API_ACTIONS.toggleQuestionnaireApiAccess(questionnaireId, tenantId, enabled))
});

export default connect(mapStateToProps, mapDispatchToProps)(QuestionaireDetails);
